import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import albaranesService from "../../../services/albaranes.service";

const initialState = {
  albaranes: [],
  status: "idle",
  error: null,
};

export const fetchAlbaranes = createAsyncThunk("albaranes/getAlbaranes", async () => {
  const response = await albaranesService.getAll({});
  return response.albaranes;
});

export const insertDevoluciones = createAsyncThunk(
  "albaranes/insertDevoluciones",
  async ({ devoluciones }) => {
    const response = await albaranesService.insertDevoluciones({ devoluciones });
    return response;
  }
);

export const albaranesSlice = createSlice({
  name: "albaranes",
  initialState: initialState,
  reducers: {
    setAlbaranes(state, action) {
      state.albaranes = action.payload;
    },
  },

  extraReducers(builder) {
    builder
      //fetchAlbaranes
      .addCase(fetchAlbaranes.pending, (state, action) => {
        state.status = "loading";
      })
      .addCase(fetchAlbaranes.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.albaranes = action.payload;
      })
      .addCase(fetchAlbaranes.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
      //insertDevoluciones
      .addCase(insertDevoluciones.pending, (state, action) => {
        state.status = "loading";
      })
      .addCase(insertDevoluciones.fulfilled, (state, action) => {
        state.status = "idle";
      })
      .addCase(insertDevoluciones.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
  },
});

export const { setAlbaranes } = albaranesSlice.actions

export const selectAllAlbaranes = (state) => state.albaranes.albaranes;

export const selectAlbaranByNumeroAlbaran = (numero_albaran) => (state) => {
  console.log({ albaranes: state.albaranes.albaranes });
  return state.albaranes.albaranes.find((albaran) => albaran.numero_albaran === numero_albaran);
};

export default albaranesSlice.reducer;
